import PropTypes from 'prop-types';
import React from 'react';
import ValidateAppointment from '../containers/ValidateAppointment';
import WaitingListApplePay from './WaitingListApplePay';
import WaitingListButton from './WaitingListButton';
import ContactInformation from '../containers/ContactInformation';
import NotDesktop from '../../components/responsiveUtilities/notDesktop';
import Desktop from '../../components/responsiveUtilities/desktop';
import OrderInformation from '../containers/OrderInformation';
import ReedemCode from '../containers/ReedemCode';
import Tip from '../containers/Tip';
import ApplePay from '../containers/ApplePay';
import Pay from '../containers/Pay';
import TermsOfService from '../containers/TermsOfService';
import ProcessingIndicator from '../containers/ProcessingIndicator';


const MakeReservation = ({
  totalAmount,
  bookNoPay,
  tipEnabled,
  userEmail,
  paymentEnabled,
  handleReserveAndPay,
  handleBookAndReserve,
  handleReserve,
  reservationTime,
  noAutofill,
  timeWaitingList,
  addCustomerToWaitingList,
  bookAndReserve,
  bookAndPayCopy,
  withApplePay,
  noExtrasForBookNoPay,
  applePay,
  applePayAddCustomerToWaitingList,
  showPromo,
}) => {
  const paymentOptions = !timeWaitingList && (
    <Pay
      totalAmount={totalAmount}
      bookNoPay={bookNoPay}
      paymentEnabled={paymentEnabled}
      email={userEmail}
      handleReserveAndPay={handleReserveAndPay}
      handleBookAndReserve={handleBookAndReserve}
      handleReserve={handleReserve}
      bookAndReserve={bookAndReserve}
      showPromo={showPromo}
    />
  );

  const waitingListPaymentOptions = timeWaitingList && (
    <WaitingListButton
      email={userEmail}
      disabled={!paymentEnabled}
      onSuccess={addCustomerToWaitingList}
    />
  );

  const noExtrasPaymentOptions = (noExtrasForBookNoPay && paymentOptions) || null;
  const noExtrasWaitingListPaymentOptions = (
    (noExtrasForBookNoPay && !withApplePay && waitingListPaymentOptions) || null
  );

  const regularPaymentOptions = (!noExtrasForBookNoPay && paymentOptions) || null;
  const regularWaitingListPaymentOptions = (
    (!noExtrasForBookNoPay && !withApplePay && waitingListPaymentOptions) || null
  );

  return (
    <div className="u-mt">
      <ValidateAppointment />
      <NotDesktop>
        <div className="c-heading u--mt u-co-teal-blue">
          Appointment time:
        </div>
        <div className="c-heading c-heading--large u-mb">
          {reservationTime}
        </div>
      </NotDesktop>
      <div className="layout layout--flush">
        <div className="layout__item u-2/3-small-plus-and-up">
          <ContactInformation noAutofill={noAutofill} />
          <div className="u-type--semibold epsilon u-co-black-2">
            {timeWaitingList && <p>
              Your credit/debit card is required in order to be placed on the
              waiting list. If there is an opening you will receive a text message
              with the time and a reservation link, You will have 10 minutes to
              accept the reservation by clicking the link in the text message. If
              the particular time does not work for you, simply ignore the text
              message. Your credit card will NOT be charged unless you accept a
              reservation by click on the link in the text message.
            </p>}
            {!timeWaitingList && <p className="u-text-justify">
              {bookAndPayCopy}
            </p>}
            <TermsOfService />
          </div>
          <Tip showOnApplePay />
          {!timeWaitingList && <ApplePay onClick={() => applePay()} />}
          {timeWaitingList && <WaitingListApplePay onClick={applePayAddCustomerToWaitingList} />}
        </div>

        <div className="layout__item u-1/3-small-plus-and-up">
          <div className="u-mt+ small-plus-and-up-ml+ small-plus-and-up-pl small-plus-and-up-mt0">
            <OrderInformation />
            {totalAmount && <ReedemCode />}
            {noExtrasPaymentOptions}
            {noExtrasWaitingListPaymentOptions}
          </div>
        </div>

        {tipEnabled &&
          <NotDesktop>
            <div className="layout__item u-2/3-small-plus-and-up">
              <Tip />
            </div>
          </NotDesktop>
        }

        <NotDesktop>
          <div className="layout__item u-1/3-small-plus-and-up">
            <div className="u-pl0 small-plus-and-up-pl u-ml0 small-plus-and-up-ml+ u-mt+ small-and-up-mt0">
              {regularPaymentOptions}
              {regularWaitingListPaymentOptions}
            </div>
          </div>
        </NotDesktop>
      </div>
      <Desktop>
        <div className="layout layout--flush medium-and-up-mt">
          <div className="layout__item u-2/3">
            <Tip />
          </div>
          <div className="layout__item u-1/3">
            <div
              className="u-ml+ u-pl"
              style={{ marginTop: 59 }}
            >
              {regularPaymentOptions}
              {regularWaitingListPaymentOptions}
            </div>
          </div>
        </div>
      </Desktop>
      <ProcessingIndicator>Processing order</ProcessingIndicator>
    </div>
  );
};

MakeReservation.propTypes = {
  totalAmount: PropTypes.number,
  bookNoPay: PropTypes.bool,
  tipEnabled: PropTypes.bool,
  handleReserveAndPay: PropTypes.func,
  handleBookAndReserve: PropTypes.func,
  handleReserve: PropTypes.func,
  paymentEnabled: PropTypes.bool,
  userEmail: PropTypes.string,
  reservationTime: PropTypes.string,
  noAutofill: PropTypes.bool,
  timeWaitingList: PropTypes.bool.isRequired,
  addCustomerToWaitingList: PropTypes.func.isRequired,
  bookAndReserve: PropTypes.bool,
  bookAndPayCopy: PropTypes.string,
  withApplePay: PropTypes.bool.isRequired,
  noExtrasForBookNoPay: PropTypes.bool.isRequired,
  applePay: PropTypes.func.isRequired,
  applePayAddCustomerToWaitingList: PropTypes.func.isRequired,
  showPromo: PropTypes.bool.isRequired,
};

MakeReservation.defaultProps = {
  totalAmount: 0,
  bookNoPay: false,
  tipEnabled: false,
  paymentEnabled: false,
  userEmail: '',
  handleReserveAndPay: null,
  handleBookAndReserve: null,
  handleReserve: null,
  applePay: null,
  reservationTime: '',
  noAutofill: false,
  bookAndReserve: false,
  bookAndPayCopy: '',
};

export default MakeReservation;



// WEBPACK FOOTER //
// ./src/app/reservation/components/MakeReservation.jsx